/* eslint-disable indent */
import { log } from '@utils/logger';
import { setupAccessibility } from '@form/setupAccessibility';
import { setupVoiceButton } from '@form/setupVoiceButton';
import { setupSubmitHandler } from '@form/setupSubmitHandler';
import { Instance } from 'types';
import i18n from '@i18n';


declare global {
	interface Window {
		CludoSearch?: any;
        cludoConfig?: any;
	}
}

/**
 * Modifies a single form to integrate AgentEx functionality.
 * Adds accessibility features, voice search, and custom submit handling.
 *
 * @param form - The HTML form element to modify.
 * @param instance - The configuration instance for this form.
 */
export function overrideForm(form: HTMLFormElement, instance: Instance): void {
	if (!form) {
		return;
	}

	form.setAttribute('data-aex-overridden', 'true');
	form.setAttribute('role', 'search');
	form.setAttribute('novalidate', '');

	// Check for Cludo to see if we need to override the form
	if (typeof window.CludoSearch !== 'undefined' || typeof window.cludoConfig !== 'undefined') {
		const clonedForm = form.cloneNode(true) as HTMLFormElement;
		form.parentNode?.replaceChild(clonedForm, form);
		form = clonedForm;
	}

	log('Overriding form:', [form]);

	const searchInput = form.querySelector(instance.searchField || 'input[type="search"]') as HTMLInputElement | null;

	if (!searchInput) {
		log(i18n.t('log.noSearchInput'), [form]);
		return;
	}

	searchInput.setAttribute('maxLength', '255');
	searchInput.setAttribute('placeholder', instance.searchFieldPlaceholder || i18n.t('searchPlaceholder'));

	// Apply accessibility attributes and labels
	setupAccessibility(form, searchInput, instance.index || '1');

	// Add voice search functionality if enabled
	if (instance.voiceSearch) {
		setupVoiceButton(form, searchInput, instance);
	}

	// Add custom submit handling
	setupSubmitHandler(form, instance);
}
